<div class="blog-area ptb-80">
  <div class="container">
    <div class="section-title">
      <h3 i18n="@@pressRoomNewsTitle">Wipperoz in the news</h3>
      <div class="bar"></div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-6 d-flex align-items-stretch h-100" *ngFor="let article of news; index as i">
        <app-news-item [newsArticle]="article"></app-news-item>
      </div>
      <div class="col-lg-12 col-md-12">
        <div class="pagination-area" *ngIf="!loading && news.length > 0">
          <ul class="pagination justify-content-center">
            <li class="page-item" [ngClass]="{ disabled: pressService.options.page === 1 }">
              <a i18n="@@prevPagePagination" class="page-link" href="javascript:void(0)" (click)="prev()">Previous</a>
            </li>
            <ng-container *ngIf="news">
              <li
                class="page-item"
                *ngFor="let number of numbers"
                [ngClass]="{ active: pressService.options.page === number }"
              >
                <a class="page-link" href="javascript:void(0)" (click)="to(number)">{{ number }}</a>
              </li>
            </ng-container>
            <li class="page-item" [ngClass]="{ disabled: pressService.options.page === numbers.length }">
              <a
                i18n="@@nextPagePagination"
                class="page-link"
                href="javascript:void(0)"
                (click)="next()"
                disabled="true"
                >Next</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
